// extracted by mini-css-extract-plugin
export default {"UserGuideVideo":"UserGuideVideo__UserGuideVideo___ViEDS","title":"UserGuideVideo__title___Z7PmU"};